import { render, staticRenderFns } from "./DashGlobal.vue?vue&type=template&id=6118c61a&"
import script from "./DashGlobal.vue?vue&type=script&lang=js&"
export * from "./DashGlobal.vue?vue&type=script&lang=js&"
import style0 from "./DashGlobal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports